app.service('basketVoucher', function (modal, loading, broker, console, cookie, message, front, log, loginModal, pageConfig, simpleToastr) {
	let $voucherInput, $error;
	let $self, config;
	let isForceExpanded = false;
	let successAdded = false;
	let successAddedMessage = false;
	let originalCode = '';

	function logEvent(params) {
		var basket = pageConfig.getData('basket');
		var plus = [];
		$(basket.items).each(function (i, n) {
			plus.push(n.plu);
		});
		log.event(Object.assign({}, {
			f03: cookie.get(front.euro ? 'euroCart' : 'oleoleCart'),
			f05: plus.join(";"),
			f06: config.summaryPrice
		}, params));
	}
	function applyVoucher(voucherCode) {
		loading.start();
		logEvent({
			id: 'apply-voucher',
			f04: voucherCode
		});
		let data = {
			voucherCode
		};
		$.ajax({
			type: 'POST',
			url: '/applyVoucherToCart.ltr',
			dataType: 'json',
			data,
			success: function (res) {
				loading.stop();
				redirectOrReloadAfterVoucherApply(res, data);
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd dodawania kodu rabatowego')
			}
		});
	}

	function removeVoucher(voucherCode) {
		loading.start();
		logEvent({
			id: 'remove-voucher',
			f04: voucherCode
		});
		$.ajax({
			type: 'POST',
			url: '/removeVoucherFromCart.ltr',
			data: { voucherCode },
			success: function () {
				broker.trigger('REFRESH_BASKET_VIEW');
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd usuwania kodu rabatowego');
			}
		});
	}

	function redirectOrReloadAfterVoucherApply(res, data) {
		$error.empty();
		$self.removeClass('voucher-change').removeClass('voucher-error').find('.validate-target').removeClass('validate-error');
		originalCode = data.voucherCode;
		if (pageConfig.getData('operator').isLogged && !pageConfig.getData('operator').frontUserLogged && res.loginNeeded){
			loading.redirect('/cart-front-operator-customer-login.bhtml');
		} else{
			if (res.loginNeeded) {
				if(config.voucherLoginModal){
					openLoginModal(data.voucherCode);
				} else {
					loading.redirect('/login.bhtml');
					return;
				}
			}
			
			if (res.errorMessage.length > 0) {

				$error.html(res.errorMessage);
				$self.addClass('voucher-error').find('.validate-target').addClass('validate-error');

			} else {
				successAdded = true;
				successAddedMessage = res.message ? res.message : false;
				broker.trigger('REFRESH_BASKET_VIEW');
			}
		}
	}

	function voucherCodeHasChagned() {
		var voucherCode = $voucherInput.val();
		return originalCode !== voucherCode;
	}
	function applyVoucherAction() {
		const voucherCode = $voucherInput.val();
		if (voucherCode.length > 0 && !/^[0-9a-zA-Z._-]+$/.test(voucherCode)) {
			showInvalidVoucherMessage();
			return false;
		}

		if (voucherCode && voucherCode.length) {
			applyVoucher(voucherCode);
		}
	}

	function showInvalidVoucherMessage() {
		modal.alert('Nieprawidłowy format kodu rabatowego!');
	}

	function removeVoucherAction(voucherCode) {
		successAdded = false;
		if (voucherCode && voucherCode.length) {
			removeVoucher(voucherCode);
		}
	}

	function handleInputKeypress(e) {
		if (e.keyCode === 13) {
			let value = $voucherInput.val();
			e.preventDefault();
			if (value !== originalCode) {
				applyVoucherAction();
			}
		}
	}

	function handleInputKeyup(e) {
		let value = $voucherInput.val();
		console.log('obecny kod rabatowy: '+value)
		if (value === originalCode) {
			$self.removeClass('voucher-change');
		} else if (e.target.value && e.target.value.length) {
			$self.addClass('voucher-change');
		}
		if (value.length == 0) {
			$self.addClass('voucher-empty');
		} else {
			$self.removeClass('voucher-empty');
		}
		if ($self.hasClass('voucher-error') && !$self.hasClass('voucher-change') && !$self.hasClass('voucher-empty')) {
			$self.find('.validate-target').addClass('validate-error');
		} else {
			$self.find('.validate-target').removeClass('validate-error');
		}
	}
	function check(callback) {
		if ($self.length && voucherCodeHasChagned()) {
			message.get('cart.bhtml - niezastosowano kodu rabatowego').then(function (m) {
				modal.generate({
					content: m,
					id: 'apply-voucher-modal',
					modifier: 'remodal-full-width',
					buttons: [{
						text: 'Przejdź dalej bez kodu',
						cssClass: 'btn-third',
						click: function () {
							modal.close();
							cleanVoucherAction(callback)
						}
					}, {
						text: 'Dodaj kod',
						cssClass: 'btn-second',
						click: function () {
							modal.close();
							applyVoucherAction();
						}
					}]
				});
			})

			return true;
		}
		return false;
	}
	function cleanVoucherAction(callback) {
		$voucherInput.val('');
		$error.empty();
		$self.removeClass('voucher-change').removeClass('voucher-error').find('.validate-target').removeClass('validate-error');
		originalCode = '';
		if (callback) {
			callback();
		}
	}

	function openLoginModal(voucherCode){
		loginModal.load({
			type: 'login-voucher',
			voucherCode: voucherCode,
			callbackSuccess: function() { 
				applyVoucherAction() 
			}
		});
	}

	function setEvents() {
		$voucherInput.keyfilter(/[\da-zA-Z\.\-\_]/);
		$self
			.on('click', '.js-accept-voucher', function () {
				applyVoucherAction();
			}).on('click', '.js-remove-voucher', function () {
				removeVoucherAction($(this).data('voucher'));
			}).on('click', '.js-clean-voucher', function () {
				cleanVoucherAction();
			}).on('click', '.js-voucher-login', function(){
				openLoginModal();
			}).on('click', '.js-toggle-voucher', function(){
				if ($self.hasClass('expand')) {
					isForceExpanded = false;
					$self.removeClass('expand');
				} else {
					isForceExpanded = true;
					$self.addClass('expand');
				}
			});

		$voucherInput.on('input', handleInputKeyup).on('keypress', handleInputKeypress);
		if (isForceExpanded) {
			$self.addClass('expand');
		}

		if(successAdded && !$self.hasClass('voucher-error')){
			successAdded = false;
			if(successAddedMessage && successAddedMessage.length){
				simpleToastr.generate(successAddedMessage, {
					closeOthers: true
				});
				successAddedMessage = false;
			}
		}
	}

	function setElements() {
		$self = $('#voucher-box');
		$voucherInput = $('#voucher-input', $self);
		$error = $('#voucher-message-error', $self);
		config = pageConfig.getData('order');
	}

	function init() {
		setElements();
		setEvents();
		originalCode = '';
	}

	return {
		init,
		check
	};
});
